import React from "react";

import Modal from 'react-modal';
const SessionTimeoutModal = ({ open, mode = 'renew', countdown, logoutTime, onLogout, onContinue, onAcknowledge, restoreError = false, busy = false }) => {
  // Prepend `0` for one digit numbers. For that the number has to be
// converted to string, as numbers don't have length method
const padTime = time => {
  return String(time).length === 1 ? `0${time}` : `${time}`;
};

const format = time => {
  // Convert seconds into minutes and take the whole part
  const minutes = Math.floor(time / 60);
  // Get the seconds left after converting minutes
  const seconds = time % 60;
  //Return combined values as string in format mm:ss
  return `${minutes}:${padTime(seconds)}`;
};

// The absolute-cap notice shows the exact wall-clock time the user will be signed out.
const formatClockTime = timestamp => {
  if (!timestamp) return "";
  return new Date(timestamp).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

// 'notice' = non-renewable absolute-cap reminder (30-minute / 5-minute); otherwise the
// ordinary renewable token-expiry warning.
const isNotice = mode === 'notice';

return (

<Modal
    className="modal sessionTimeoutModal"
    overlayClassName="modalOverlay"
    aria-modal="true"
    contentLabel={isNotice ? "Session Ending Soon" : "Session Timeout"}
    shouldCloseOnOverlayClick={false}
    isOpen={open}
    style={{
      overlay: { zIndex: 1100 }, // ensure timeout modal displays on top of other modals
      content: { zIndex: 1101 },
    }}
    >
    <div className="modalHeader">{isNotice ? "Session Ending Soon" : "Session Timeout Reminder"}</div>
      <div className="modalContent">
        {isNotice ? (
          <>
            Your ED3N session will reach its maximum length and end at{" "}
            <span className="countdown">{formatClockTime(logoutTime)}</span>.
            <p>This is the maximum session length and cannot be extended. Please save your work; you will need to sign in again to continue using ED3N.</p>
          </>
        ) : (
          <>
            The current session is about to expire in{" "}
            <span className="countdown">{format(countdown)}</span>.
            <p>Would you like to continue the session?</p>
            {restoreError && (
              <p role="alert">
                Something went wrong and the session could not be renewed. Please try again.
              </p>
            )}
          </>
        )}
      </div>
    <div className="modalButtons">
        {isNotice ? (
          <button onClick={onAcknowledge} className="modalButton primaryButton">
                OK
          </button>
        ) : (
          <>
            <button onClick={onLogout} className="modalButton defaultButton">
                    Logout
            </button>
            <button onClick={onContinue} className="modalButton primaryButton" disabled={busy}>
                    {busy ? "Continuing…" : restoreError ? "Try Again" : "Continue Session"}
            </button>
          </>
        )}
    </div>
</Modal>
);
}
export default SessionTimeoutModal;